document.addEventListener("DOMContentLoaded", () => {
  const carouselInner = document.querySelector(".testimonial-carousel-inner");
  const paginationContainer = document.querySelector(".carousel-pagination");
  const prevBtn = document.querySelector(".prev-btn");
  const nextBtn = document.querySelector(".next-btn");

  let cards = [...document.querySelectorAll(".testimonial-card")];
  let currentIndex = 2;
  let isTransitioning = false;
  let autoPlayInterval;
  const cloneCount = 2;

  function setupCarousel() {
    if (window.innerWidth <= 768) return;

    const numOriginal = cards.length;

    for (let i = 0; i < cloneCount; i++) {
      const cloneStart = cards[numOriginal - 1 - i].cloneNode(true);
      const cloneEnd = cards[i].cloneNode(true);
      carouselInner.insertBefore(cloneStart, carouselInner.firstChild);
      carouselInner.appendChild(cloneEnd);
    }

    currentIndex = cloneCount;
    cards = [...document.querySelectorAll(".testimonial-card")];
    updatePosition(false);
    updateVisuals();
  }

  function updatePosition(transition = true) {
    const card = cards[0];
    const cardWidth = card.offsetWidth;
    const margin = parseInt(getComputedStyle(card).marginLeft) * 2;
    const totalCardWidth = cardWidth + margin;
    const offset =
      carouselInner.parentElement.offsetWidth / 2 - totalCardWidth / 2;
    const newTransform = `translateX(${
      offset - currentIndex * totalCardWidth
    }px)`;

    carouselInner.style.transition = transition ? "transform 0.6s ease" : "none";
    carouselInner.style.transform = newTransform;
    updateVisuals();
  }

  function updateVisuals() {
    cards.forEach((card, i) => {
      card.classList.remove("active", "prev-1", "next-1", "prev-2", "next-2");
      if (i === currentIndex) card.classList.add("active");
      else if (i === currentIndex - 1) card.classList.add("prev-1");
      else if (i === currentIndex - 2) card.classList.add("prev-2");
      else if (i === currentIndex + 1) card.classList.add("next-1");
      else if (i === currentIndex + 2) card.classList.add("next-2");
    });

    document.querySelectorAll(".pagination-bar").forEach((bar, i) => {
      bar.classList.toggle("active", i === (currentIndex - cloneCount));
    });
  }

  function moveTo(index) {
    if (isTransitioning) return;
    isTransitioning = true;
    currentIndex = index;
    updatePosition();
    resetAutoPlay();
  }

  function handleTransitionEnd() {
    isTransitioning = false;
    const originalLength = cards.length - 2 * cloneCount;
    if (currentIndex >= originalLength + cloneCount) {
      currentIndex = cloneCount;
      updatePosition(false);
    }
    if (currentIndex < cloneCount) {
      currentIndex = originalLength + cloneCount - 1;
      updatePosition(false);
    }
  }

  function startAutoPlay() {
    if (window.innerWidth <= 768) return;
    autoPlayInterval = setInterval(() => moveTo(currentIndex + 1), 4000);
  }

  function resetAutoPlay() {
    clearInterval(autoPlayInterval);
    startAutoPlay();
  }

  // Event Listeners
  carouselInner.addEventListener("transitionend", handleTransitionEnd);
  nextBtn.addEventListener("click", () => moveTo(currentIndex + 1));
  prevBtn.addEventListener("click", () => moveTo(currentIndex - 1));
  carouselInner.addEventListener("mouseenter", () => clearInterval(autoPlayInterval));
  carouselInner.addEventListener("mouseleave", startAutoPlay);

  setupCarousel();
  startAutoPlay();
});

